import React, { useEffect, useState } from "react";
import "./form.scss";

const Form = (props: any) => <form className="ui-form">{props.children}</form>;

export default Form;
